var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAeur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#051D2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99606 11.2421C8.21808 11.2421 7.45757 11.0114 6.81069 10.5792C6.16382 10.147 5.65965 9.53264 5.36193 8.81387C5.0642 8.09511 4.98631 7.3042 5.13808 6.54116C5.28986 5.77813 5.6645 5.07723 6.21462 4.52712C6.76473 3.977 7.46563 3.60236 8.22866 3.45058C8.9917 3.29881 9.78261 3.3767 10.5014 3.67443C11.2201 3.97215 11.8345 4.47632 12.2667 5.12319C12.6989 5.77007 12.9296 6.53058 12.9296 7.30856C12.9283 8.3514 12.5134 9.35114 11.776 10.0885C11.0386 10.8259 10.0389 11.2408 8.99606 11.2421ZM9 7.28494C8.99455 7.28494 8.98922 7.28656 8.98469 7.28958C8.98016 7.29261 8.97662 7.29692 8.97454 7.30195C8.97245 7.30699 8.97191 7.31253 8.97297 7.31788C8.97403 7.32323 8.97666 7.32814 8.98051 7.33199C8.98437 7.33585 8.98928 7.33847 8.99462 7.33953C8.99997 7.3406 9.00551 7.34005 9.01055 7.33797C9.01559 7.33588 9.01989 7.33235 9.02292 7.32781C9.02595 7.32328 9.02756 7.31795 9.02756 7.3125C9.02693 7.30526 9.02376 7.29846 9.01862 7.29332C9.01348 7.28818 9.00669 7.28501 8.99944 7.28438L9 7.28494Z",
    fill: "url(#paint0_linear_722_32974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99606 15.1796C8.21808 15.1796 7.45757 14.9489 6.81069 14.5167C6.16382 14.0845 5.65965 13.4701 5.36193 12.7514C5.0642 12.0326 4.98631 11.2417 5.13808 10.4787C5.28986 9.71563 5.6645 9.01473 6.21462 8.46462C6.76473 7.9145 7.46563 7.53986 8.22866 7.38808C8.9917 7.23631 9.78261 7.3142 10.5014 7.61193C11.2201 7.90965 11.8345 8.41382 12.2667 9.06069C12.6989 9.70757 12.9296 10.4681 12.9296 11.2461C12.9283 12.2889 12.5134 13.2886 11.776 14.026C11.0386 14.7634 10.0389 15.1783 8.99606 15.1796ZM9 11.2224C8.99455 11.2224 8.98922 11.2241 8.98469 11.2271C8.98016 11.2301 8.97662 11.2344 8.97454 11.2395C8.97245 11.2445 8.97191 11.25 8.97297 11.2554C8.97403 11.2607 8.97666 11.2656 8.98051 11.2695C8.98437 11.2733 8.98928 11.276 8.99462 11.277C8.99997 11.2781 9.00551 11.2776 9.01055 11.2755C9.01559 11.2734 9.01989 11.2698 9.02292 11.2653C9.02595 11.2608 9.02756 11.2555 9.02756 11.25C9.02693 11.2428 9.02376 11.236 9.01862 11.2308C9.01348 11.2257 9.00669 11.2225 8.99944 11.2219L9 11.2224Z",
    fill: "url(#paint1_linear_722_32974)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_722_32974",
    x1: 398.419,
    y1: 3.375,
    x2: 398.419,
    y2: 1130.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "white",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_722_32974",
    x1: 398.419,
    y1: 7.3125,
    x2: 398.419,
    y2: 1134.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "white",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "white",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "white",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "white",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAeur);
export default __webpack_public_path__ + "static/media/aeur.bbde0d021b7d66633e21b680b7cb66b8.svg";
export { ForwardRef as ReactComponent };